import type {FC} from 'react';

import {Container} from 'components/container';
import type {TextSchema} from 'components/content-blocks/text/schema';
import {PortableText} from 'components/portable-text';

interface Props {
	section: TextSchema;
	isDraft: boolean;
}

export const Text: FC<Props> = ({section, isDraft}) => {
	const {content} = section;

	return (
		<Container layout={section.layout}>
			{content && <PortableText blocks={content} isDraft={isDraft} />}
		</Container>
	);
};
